import axios from 'axios'
import API from '@/common/api'
import store from '..'

export default {
  namespaced: true,
  state: {
    setting: {},
    list: []
  },
  mutations: {
  },
  actions: {
    async getSetting ({ dispatch, state }) {
      const file = 'tv/setting.json'
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        state.setting = res.data.message
        return res.data.message
      } catch (ex) {
        return false
      }
    },
    async getChannel ({ dispatch, state }) {
      const file = 'tv/channel.json'
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        const channelList = res.data.message.filter(x => x.no)
        state.list = channelList
        return channelList
      } catch (ex) {
        return false
      }
    },
    async setTvControl ({ state }, data) {
      const cmd = data.cmd.toString().toLowerCase()
      const tv = data.tv
      const type = data.type
      const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : store.state.authentication.k
      if (data.cmd) {
        return axios.put(`${API.BASE_URL}/${API.SITE_INFO.site}/${API.SITE_INFO.space}/tv/${ota}`, {
          cmd: cmd,
          tv: tv,
          type: type
        }).then(res => {
          return res
        }).catch((ex) => {
          return ex.response
        })
      } else {
        return false
      }
    },
    async getTvIndex ({ state }) {
      try {
        const siteInfo = API.SITE_INFO
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-manage',
          func: 'get-tv-index',
          siteid: siteInfo.site,
          spaceid: siteInfo.space
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    }
  },
  getters: {
    getChannelList: state => state.list,
    getSetting: state => state.setting
  }
}
